import { ArrowUpRight, Menu, Phone } from 'lucide-react'
import { site } from '../content/site'
import { BrandMark } from './BrandMark'

const navItems = [
  { href: '/services/', label: 'Services' },
  { href: '/insights/', label: 'Insights' },
  { href: '/contact/', label: 'Contact' },
]

export function Header() {
  return (
    <header className="site-header">
      <div className="shell site-header__inner">
        <a className="site-header__brand" href="/">
          <BrandMark />
        </a>
        <nav className="site-header__nav" aria-label="Primary navigation">
          {navItems.map((item) => <a key={item.href} href={item.href}>{item.label}</a>)}
        </nav>
        <div className="site-header__actions">
          <a className="header-phone" href={site.phoneHref}>
            <Phone aria-hidden="true" />
            <span>{site.phoneDisplay}</span>
          </a>
          <a className="button button--small button--light" href="/contact/">
            Plan a project <ArrowUpRight aria-hidden="true" />
          </a>
        </div>
        <details className="mobile-menu">
          <summary aria-label="Open navigation"><Menu aria-hidden="true" /></summary>
          <nav aria-label="Mobile navigation">
            {navItems.map((item) => <a key={item.href} href={item.href}>{item.label}</a>)}
            <a href={site.phoneHref}>{site.phoneDisplay}</a>
          </nav>
        </details>
      </div>
    </header>
  )
}
